import React, { useEffect, useState } from "react";

// Lightweight, dependency-free confetti burst. Renders ~pieces divs from the
// top of the viewport that fall + tumble via a single CSS keyframe. Auto-clears
// after `duration` ms so it doesn't hang around in the DOM.
const COLORS = [
  "#7c3aed", // primary purple
  "#a78bfa",
  "#c4b5fd",
  "#f59e0b",
  "#10b981",
  "#ec4899",
  "#3b82f6",
];

export default function Confetti({ active, pieces = 90, duration = 2800 }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!active) { setItems([]); return; }
    const arr = Array.from({ length: pieces }).map((_, i) => ({
      id: `${Date.now()}-${i}`,
      left: Math.random() * 100,
      delay: Math.random() * 500,
      duration: 1600 + Math.random() * 1400,
      rotate: Math.random() * 360,
      color: COLORS[i % COLORS.length],
      w: 6 + Math.random() * 6,
      h: 10 + Math.random() * 10,
      rounded: Math.random() > 0.5,
      drift: (Math.random() - 0.5) * 220,
    }));
    setItems(arr);
    const t = setTimeout(() => setItems([]), duration + 600);
    return () => clearTimeout(t);
  }, [active, pieces, duration]);

  if (!items.length) return null;
  return (
    <div
      className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden"
      aria-hidden
      data-testid="confetti-layer"
    >
      {items.map((p) => (
        <span
          key={p.id}
          className="absolute top-0 mano-confetti-fall"
          style={{
            left: `${p.left}%`,
            width: p.w,
            height: p.h,
            backgroundColor: p.color,
            borderRadius: p.rounded ? "9999px" : "2px",
            transform: `rotate(${p.rotate}deg)`,
            animationDuration: `${p.duration}ms`,
            animationDelay: `${p.delay}ms`,
            "--mano-confetti-drift": `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
